import { styled } from 'styled-components';

import { Headings } from '../Headings';
import { Container } from '../Layout';
import { Text } from '../Text';

const IconWrapper = styled.div`
  position: absolute;
  top: -1.25rem;
`;

type MessageCardProps = {
  illustration: React.ReactNode;
  headingText?: string;
  bodyText: string | JSX.Element;
};

/** @deprecated Use SpeechBubble instead */
export const MessageCard = ({ illustration, headingText, bodyText }: MessageCardProps) => {
  return (
    <Container
      backgroundColor="black05"
      paddingTop={40}
      paddingBottom={60}
      marginRight={[-20, -40, -40]}
      marginLeft={[-20, -40, -40]}
      paddingRight={[20, 40, 40]}
      paddingLeft={[20, 40, 40]}
      width={['auto', 'auto', 658]}
      position="relative"
      borderRadius="2px"
    >
      <IconWrapper>{illustration}</IconWrapper>
      {headingText && <Headings.H5 marginBottom={6}>{headingText}</Headings.H5>}
      {typeof bodyText === 'string' ? <Text whiteSpace="pre-line">{bodyText}</Text> : bodyText}
    </Container>
  );
};
